import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import { GetEnumsRequest, GetEnumsResponse } from "../models/enum.model";
import { ApiBaseUrl, EnumUrl } from "../config/config";

export const GetEnums = async (
  data: GetEnumsRequest
): Promise<GetEnumsResponse[]> => {
  return await Axios.post<ApiResultModel<GetEnumsResponse[]>>(
    ApiBaseUrl + EnumUrl + "/GetEnums",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const getEnumsPersian = async (
  data: GetEnumsRequest
): Promise<GetEnumsResponse[]> => {
  return await Axios.post<ApiResultModel<GetEnumsResponse[]>>(
    ApiBaseUrl + EnumUrl + "/GetEnumsPersian",
    data
  ).then((result) => {
    return result.data.data;
  });
};
